import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ZeroDCDetailed = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'requestDate',
				accessor: 'requestDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true
			},
			{
				Header: 'originCountry',
				accessor: 'originCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'originCity',
				accessor: 'originCity',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'originDistrict',
				accessor: 'originDistrict',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'destinationCountry',
				accessor: 'destinationCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'destinationCity',
				accessor: 'destinationCity',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'destinationDistrict',
				accessor: 'destinationDistrict',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'grandTotal',
				accessor: 'grandTotal',
				filterType: FilterType.float,
				showOnMobile: true
			},
			{
				Header: 'weight',
				accessor: 'weight',
				filterType: FilterType.number,
				width: 50,
				showOnMobile: true
			},
			{
				Header: 'volumetricWeight',
				accessor: 'volumetricWeight',
				filterType: FilterType.number,
				width: 150,
				showOnMobile: true
			},
			{
				Header: 'hasOrder',
				accessor: 'hasOrder',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				showOnMobile: true
			},
			{
				Header: 'orderID',
				accessor: 'orderId',
				filterType: FilterType.string,
				width: 100,
				showCopyButton: true,
				showOnMobile: true
			},

			{
				Header: 'clientCountry',
				accessor: 'country',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'clientEmail',
				accessor: 'clientEmail',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'clientPhone',
				accessor: 'clientPhone',
				width: 90,
				filterType: FilterType.string,
				renderCell: ListComponents.PHONE,
				showOnMap: true,
				showOnMobile: true
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string,
				width: 200,
				showOnMobile: true
			},
			{
				Header: 'requestJSON',
				accessor: 'payload',
				filterType: FilterType.string,
				width: 100,
				showCopyButton: true
			}
		],
		[]
	);
	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((c) => c.accessor === 'requestDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(1, 'day').endOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'requestDate', desc: true }], []);
	const filtersFromRouter = useRouterFilters(columns);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.ZERO_DC_DETAILED_LIST}
				columns={columns}
				defaultFilters={filtersFromRouter ?? defaultFilters}
				fetchUrl={REPORT.DC.GET_ZERO_DC_DETAILED_LIST}
				exportName="zeroDCDetailedListExport"
				infiniteScroll
				defaultSort={defaultSort}
				disableInfiniteScrollUp
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
			/>
		</TabTableContainer>
	);
};

export default ZeroDCDetailed;
